import fetchManager from '@utils/fetchManager'
import { urlQueryData, getEnvironment } from '@utils/general'

const API_URL = getEnvironment("API_DOMAIN");

export default {
  getPositions: async () => {
    const errorModal = { show: 'no' }

    const response = await fetchManager(`${API_URL}/CatalogueManagement/api/amx/cpe/users/internal/position`, {}, errorModal)
    return response
  }
}